// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__-v5Rj","title":"Sidebar_title__70bpJ"};